"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _Changes = _interopRequireDefault(require("lead-flows-ui/constants/Changes"));

var ChangesList =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(ChangesList, _PureComponent);

  function ChangesList() {
    (0, _classCallCheck2.default)(this, ChangesList);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ChangesList).apply(this, arguments));
  }

  (0, _createClass2.default)(ChangesList, [{
    key: "langKey",
    value: function langKey(suffix) {
      return "leadFlows.changes." + suffix;
    }
  }, {
    key: "renderInnerList",
    value: function renderInnerList(changesList, type) {
      if (!changesList.length) return null;
      var noDetails = ['type'];
      var hasDetails = noDetails.indexOf(type) === -1;
      var filteredChanges = changesList.map(function (change) {
        return _Changes.default[type] && _Changes.default[type][change];
      }).filter(function (change, index, arr) {
        return arr.indexOf(change) === index;
      });

      var step = _I18n.default.text(this.langKey("steps." + type));

      return _react.default.createElement("div", null, _react.default.createElement("strong", null, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('stepUpdated'),
        options: {
          step: step
        }
      }), hasDetails ? ': ' : ' '), hasDetails && filteredChanges.map(function (change) {
        return _react.default.createElement("span", {
          key: change
        }, _react.default.createElement(_FormattedMessage.default, {
          message: change
        }));
      }).reduce(function (prev, curr) {
        return [prev, ', ', curr];
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var changes = this.props.changes;
      var typeChange = changes && changes.filter(function (change) {
        return change === 'type';
      });
      var calloutChanges = changes && changes.filter(function (change) {
        return _Changes.default.callout[change];
      });
      var formChanges = changes && changes.filter(function (change) {
        return _Changes.default.form[change];
      });
      var thankYouChanges = changes && changes.filter(function (change) {
        return _Changes.default.thanks[change];
      });
      var folloUpChange = changes && changes.filter(function (change) {
        return _Changes.default['follow-up'][change];
      });
      var audienceChanges = changes && changes.filter(function (change) {
        return _Changes.default.audience[change];
      });
      var optionsChanges = changes && changes.filter(function (change) {
        return _Changes.default.options[change];
      });
      if (!changes) return null;
      return _react.default.createElement("div", {
        className: "changes-list"
      }, _react.default.createElement(_UIList.default, {
        className: "changes-list__list p-left-0",
        childClassName: "changes-list__list__item m-bottom-2",
        styled: true
      }, this.renderInnerList(typeChange, 'type'), this.renderInnerList(calloutChanges, 'callout'), this.renderInnerList(formChanges, 'form'), this.renderInnerList(thankYouChanges, 'thanks'), this.renderInnerList(folloUpChange, 'follow-up'), this.renderInnerList(audienceChanges, 'audience'), this.renderInnerList(optionsChanges, 'options')));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        changes: _react.PropTypes.array.isRequired
      };
    }
  }]);
  return ChangesList;
}(_react.PureComponent);

exports.default = ChangesList;
module.exports = exports.default;